import React, { useRef, useEffect, useState, useContext } from "react";
import { fabric } from "fabric";
import { CanvasContext } from "../../Components/core/workspace/CanvasContext";

const DetachImageCanvas = () => {
  const { canvas, canvasRef } = useContext(CanvasContext);
  const [uploadedImage, setUploadedImage] = useState(null);

  useEffect(() => {
    const canvas = new fabric.Canvas(canvasRef.current);

    // Create a frame for the image
    const frame = new fabric.Rect({
      left: 50,
      top: 50,
      width: 200,
      height: 150,
      fill: "transparent",
      stroke: "black",
      strokeWidth: 2,
    });

    canvas.add(frame);

    // Function to detach the image from the frame
    const detachImage = () => {
      if (uploadedImage) {
        canvas.add(uploadedImage);
        uploadedImage.center();
        canvas.remove(frame);
        canvas.renderAll();
      }
    };

    // Just for demonstration purposes, adding a button to detach the image
    const detachButton = document.createElement("button");
    detachButton.innerText = "Detach Image";
    detachButton.addEventListener("click", detachImage);
    document.body.appendChild(detachButton);

    return () => {
      document.body.removeChild(detachButton);
    };
  }, [uploadedImage]);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      fabric.Image.fromURL(URL.createObjectURL(file), (img) => {
        img.scaleToWidth(200); // Scale the image to fit the frame width
        img.scaleToHeight(150); // Scale the image to fit the frame height
        img.set({ left: 50, top: 50 });
        setUploadedImage(img);
        canvas.renderAll();
      });
    }
  };

  return (
    <div>
      <input type="file" accept="image/*" onChange={handleImageUpload} />
      <canvas ref={canvasRef} width={800} height={600} />
    </div>
  );
};

export default DetachImageCanvas;
